import { writable } from 'svelte/store';

export const snackbarStore = writable({
  isOpen: false,
  message: '',
  type: 'info', // 'info', 'success', 'error', 'warning'
  duration: 3000,
  showCloseIcon: true,
});

/**
 * Opens the snackbar with the given message and settings.
 *
 * @param {string} message - The message to display in the snackbar.
 * @param {'info' | 'success' | 'error' | 'warning'} [type='info'] - The type of the snackbar. Can be one of 'info', 'success', 'error', 'warning'.
 * @param {number} [duration=3000] - The duration for which the snackbar should be displayed in milliseconds.
 * @param {boolean} [showCloseIcon=true] - Whether to show the close icon or not.
 */
export const showSnackbar = (message, type = 'info', duration = 3000, showCloseIcon = true) => {
  // Basic error handling for invalid input types
  if (typeof message !== 'string') {
    console.error('Invalid input for snackbar: message should be a string.');
    return;
  }

  if (!['info', 'success', 'error', 'warning'].includes(type)) {
    console.error(
      `Invalid input for snackbar: type should be one of "info", "success", "error", "warning", but got "${type}".`
    );
    return;
  }

  if (typeof duration !== 'number' || duration <= 0) {
    console.error(`Invalid duration value. Duration should be a positive number, but got ${duration}.`);
    return;
  }

  snackbarStore.set({
    isOpen: true,
    message,
    type,
    duration,
    showCloseIcon,
  });

  // Close the snackbar after the given duration
  setTimeout(() => {
    snackbarStore.update(state => ({ ...state, isOpen: false }));
  }, duration);
};

/**
 * Manually closes the snackbar.
 *
 * @function
 */
export const closeSnackbar = () => {
  snackbarStore.update(state => ({ ...state, isOpen: false }));
};
